module.exports = __webpack_public_path__ + "media/images/new-user-icon-63b9cdd7.png";